module.exports = __webpack_public_path__ + "static/media/video-2.c837e0b1.mp4";